import React, { useState, useEffect } from "react";
import { API_BASE_URL } from "../../../config";
import { useNavigate, useParams } from "react-router-dom";

const OnlineCheckout = () => {
  const { cliente_id } = useParams();
  const navigate = useNavigate();
  const [cart, setCart] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
    setCart(storedCart);
  }, []);

  const calculateTotalAmount = () => {
    return cart.reduce((acc, item) => {
      const modifiersTotal = item.selectedModifiers
        ? Object.values(item.selectedModifiers).flat().reduce((sum, mod) => sum + (mod.price || 0), 0)
        : 0;

      return acc + (item.price || 0) + modifiersTotal;
    }, 0) * 100; // Convertir a centavos para Clover
  };

  const processPayment = async () => {
    if (cart.length === 0) {
      alert("El carrito está vacío.");
      return;
    }

    setLoading(true);
    const amount = calculateTotalAmount();

    try {
      const response = await fetch(`${API_BASE_URL}/orders/${cliente_id}/pay`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items: cart, cliente_id, amount })
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || "Pago exitoso. Orden confirmada.");
        localStorage.removeItem("cart");
        navigate(`/ordenar-en-linea/${cliente_id}`);
      } else {
        alert(data.error || "Error al procesar el pago.");
      }
    } catch (error) {
      console.error("Error al procesar el pago:", error);
      alert("Error al procesar el pago.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Finalizar Pedido</h2>
      <button className="btn btn-success" onClick={processPayment} disabled={loading}>
        {loading ? "Procesando..." : "Pagar con Clover"}
      </button>
    </div>
  );
};

export default OnlineCheckout;
